<micro-select-combo #sel
              placeholder="Rating Unit"
              [mode]="mode"
              [(id)]="ratingUnit"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
